<!-- src\components\Group463.vue -->

<template>
  <div :class="[`group-463`, className || ``]">
    <div class="group-title poppins-semi-bold-white-22px">Направления обучения</div>
    <a href="#" class="text-link poppins-normal-boulder-22px" @click.prevent="handleClick('management')">Управление и бизнес</a>
    <a href="#" class="text-link poppins-normal-boulder-22px" @click.prevent="handleClick('analytics')">Аналитика и финансы</a>
    <a href="#" class="text-link poppins-normal-boulder-22px" @click.prevent="handleClick('accounting')">Бухгалтерия</a>
    <a href="#" class="text-link poppins-normal-boulder-22px" @click.prevent="handleClick('marketing')">Маркетинг</a>
  </div>
</template>

<script>
export default {
  name: "Group463",
  props: ["className"],
  methods: {
    handleClick(section) {
      console.log('Клик по разделу:', section);
      // Заглушка - здесь будет навигация
      // this.$router.push(`/courses/${section}`);
    }
  }
};
</script>

<style scoped>
.group-463 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;              /* Равномерные отступы между элементами */
  left: 82px;
  position: absolute;
  top: 560px;
  width: 299px;
  text-align: left;
}

.group-title {
  letter-spacing: 0.88px;
  line-height: 1.4;
  white-space: nowrap;    /* Не переносить заголовок */
}

.text-link {
  display: block;
  letter-spacing: 0.88px;
  line-height: 1.4;       /* Вместо фиксированной высоты */
  text-align: left;
  cursor: pointer;
  color: #797979;
  transition: color 0.3s ease;
  text-decoration: none;
  white-space: nowrap;    /* Не переносить текст */
}

.text-link:hover {
  color: #ffffff;
}

.group-463.group-463-1,
.group-463.group-463-2,
.group-463.group-463-3,
.group-463.group-463-4,
.group-463.group-463-5,
.group-463.group-463-6,
.group-463.group-463-7,
.group-463.group-463-8,
.group-463.group-463-9,
.group-463.group-463-10,
.group-463.group-463-11,
.group-463.group-463-12,
.group-463.group-463-13 {
  left: unset;
  position: unset;
  top: unset;
}
</style>